import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import CaptchaPlaceHolderUi from 'common/components/entities/Recaptcha/ui/CaptchaPlaceholderUi'
import { RecaptchaInterface } from 'common/types/entities/RecaptchaInterface'
import React from 'react'
import { EntityProps } from '../../../types'

export default function Recaptcha({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<RecaptchaInterface>) {
  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
      flex
      flexColumn
    >
      <CaptchaPlaceHolderUi
        alignSelf={entity.alignSelf}
        mobileAlignSelf={entity.mobileAlignSelf}
        src={
          entity.theme === 'light'
            ? 'https://developers.google.com/recaptcha/images/light.png'
            : 'https://developers.google.com/recaptcha/images/dark.png'
        }
      />
    </BaseEntityNew>
  )
}
